var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagereact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 4c-1.09306 0-2 .90694-2 2v12c0 1.0931.90694 2 2 2h16c1.0931 0 2-.9069 2-2v-12c0-1.09306-.9069-2-2-2zm0 2h16v12h-16zm10.5 5-3.5 4-2.5-2.5-2.72266 3.5h12.47266z",
    fill: "currentColor"
  })));
}
export default SvgImagereact;